import { API, Storage } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

import EquipmentTypeDocumentForm from "components/equipmentTypes/documents/EquipmentTypeDocumentForm";
import { createEquipmentTypeDocument } from "graphql/mutations";
import LoaderFullScreen from "components/utils/LoaderFullScreen";

const EquipmentTypeDocumentCreateForm = ({ equipmentTypeID, onSuccess }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const equipmentTypeDocument = {
    fileName: "",
    fileSrc: "",
  };

  async function onSubmit(valuesParam) {
    try {
      setLoading(true);

      const { fileName, fileSrc: fileObj } = valuesParam;
      let fileSrc = "";

      if (fileObj) {
        fileSrc = `${fileObj.name
          .split(".")
          .slice(0, -1)
          .join(".")}_${Date.now()}.${fileObj.name.split(".").slice(-1)[0]}`;

        await Storage.put(`equipment-types/${fileSrc}`, fileObj, {
          contentType: fileObj.type,
          level: "public",
        });
      }

      await API.graphql({
        query: createEquipmentTypeDocument.replaceAll("__typename", ""),
        variables: {
          input: {
            equipmentTypeID,
            fileName,
            fileSrc,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/equipment-types");
    } catch (err) {
      console.log("Error EquipmentType Document creation", err);
      toast.error(strings.responses.unexpectedError);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <EquipmentTypeDocumentForm
        onSubmit={onSubmit}
        initialValues={equipmentTypeDocument}
      />
      {loading && <LoaderFullScreen />}
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Documento de Tipo de Equipo",
    successAdded: "Documento de Tipo de Equipo agregado con éxito",
    responses: {
      unexpectedError: "Error inesperado en la creación",
    },
  },
});

export default EquipmentTypeDocumentCreateForm;
